import { render } from "./FloorPlanTypes.vue?vue&type=template&id=6cc5c8b7&scoped=true"
import script from "./FloorPlanTypes.vue?vue&type=script&lang=js"
export * from "./FloorPlanTypes.vue?vue&type=script&lang=js"

import "./FloorPlanTypes.vue?vue&type=style&index=0&id=6cc5c8b7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc5c8b7"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr});
